export default "__VITE_ASSET__a9b1ea20__"